import {
	Box,
	Button,
	Card,
	Divider,
	Flex,
	Heading,
	SimpleGrid,
	Stack,
	Text,
	useColorModeValue,
} from '@chakra-ui/react';
import { NAVIGATE } from 'constant/navigation';
import { useLocation, useNavigate } from 'react-router-dom';
import EducationLinks from 'views/client/education/components/EducationLinks';

export default function Security() {
	const textColor = useColorModeValue('gray.900', 'gray.100');
	const cardBg = useColorModeValue('gray.100', 'gray.500');
	const navigate = useNavigate();
	const location = useLocation();
	let isClient = false;
	if (location.pathname.includes('client')) isClient = true;

	return (
		<Box
			maxW={isClient ? '' : '900px'}
			alignSelf={isClient ? '' : 'center'}
			pt={isClient ? { base: '80px', md: '80px', xl: '80px' } : '0'}
		>
			<SimpleGrid
				mb='20px'
				columns={{ sm: 1, md: 1, lg: 1 }}
				spacing={{ base: '20px' }}
			>
				<Heading color={textColor} fontSize='2xl' ms='24px' fontWeight='700'>
					Seguridad y privacidad en Bumbei
				</Heading>
				<Flex direction='column'>
					<Card bg={cardBg} mb={isClient ? '20px' : '50px'} p={6}>
						<Stack spacing={6}>
							<Heading size='md' color={textColor}>
								🔐 Simple. Transparente.
							</Heading>
							<Text fontSize='md' color={textColor}>
								En Bumbei nos tomamos tu seguridad en serio. No pedimos datos
								financieros, ni guardamos tarjetas. Solo necesitas un correo y
								una dirección Lightning para cobrar.
							</Text>

							<Divider borderColor={textColor} />

							<Heading size='md' color={textColor}>
								🔎 ¿Qué datos guardamos?
							</Heading>

							<Text fontSize='md' color={textColor}>
								Solo registramos tu actividad relacionada a los clics y compras
								para poder procesar tu cashback. Esta información se guarda de
								forma segura y nunca se vende a terceros.
							</Text>

							<Divider borderColor={textColor} />

							<Heading size='md' color={textColor}>
								🧾 ¿Cómo me protejo?
							</Heading>

							<Text fontSize='md' color={textColor}>
								Usa una contraseña segura y evita compartir tu cuenta. Si
								detectamos actividad sospechosa, congelamos temporalmente el
								acceso y te notificamos por correo.
							</Text>

							{isClient && (
								<Box pt={4}>
									<Button
										as='a'
										onClick={() => navigate(NAVIGATE.EDUCATION_CENTER)}
										variant='brand'
									>
										Volver al centro educativo
									</Button>
								</Box>
							)}
						</Stack>
					</Card>
					<EducationLinks current={'security'} isClient={isClient} />
				</Flex>
			</SimpleGrid>
		</Box>
	);
}
